<template>
  <div class="banner">
    <div class="mm" :style="{background: 'url('+imgUrl+')', backgroundSize: '100% 100%'}"></div>
    <div class="banner-img">
      <img :src="imgUrl" />
    </div>
    <div class="banner-title">
      <p>{{title}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    img: {
      type: String,
      default: "https://lilishop.oss-cn-beijing.aliyuncs.com/tgrhome_bgtop.jpg"
    }
  },
  data() {
  	return{
		imgUrl: "",
	}
  },
  mounted() {
  	this.getStaticData()
  },
  methods: {
	getStaticData(){
		this.$http
		  .get("api-homepage/home/homepage/filePath?fileName=&fileType=banner图")
		   .then(res =>{
			   let resData = res.data.data;
			   this.imgUrl = resData[0].filePath;
		   })
	},	  
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 300px;
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  .mm {
    position: absolute;
    width: 100%;
    height: 100%;

    padding: 10px;
    margin: -10px;
    filter: blur(10px);

    // background-image: url(https://lilishop.oss-cn-beijing.aliyuncs.com/tgrhome_bgtop.jpg);
    background-position: center;
    background-size: 100%;
  }

  img {
    position: absolute;
    //width: 1240px;
    height: 100%;
    left: 50%;
    transform: translate(-50%, 0);
  }

  &-title {
    position: absolute;
    color: #fff;
    font-size: 45px;
    font-weight: 400;
    line-height: 300px;
    text-align: center;
    width: 100%;
  }
}
</style>